"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcDataTableHeaderBehavior = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var bc_data_table_constants_1 = require("./bc-data-table-constants");
var bc_data_table_footer_behavior_1 = require("./bc-data-table-footer-behavior");
var bc_data_table_header_paginator_behavior_1 = require("./bc-data-table-headers/bc-data-table-header-paginator-behavior");
var bc_data_table_header_settings_behavior_1 = require("./bc-data-table-headers/bc-data-table-header-settings-behavior");
var bc_data_table_header_selection_behavior_1 = require("./bc-data-table-headers/bc-data-table-header-selection-behavior");
var BcDataTableHeaderBehavior = (function () {
    function BcDataTableHeaderBehavior(bcDataTableConfig) {
        this.bcDataTableConfig = bcDataTableConfig;
        this.bcDataTableHeaderSettingsBehavior = new bc_data_table_header_settings_behavior_1.BcDataTableHeaderSettingsBehavior(this.bcDataTableConfig);
        this.bcDataTableHeaderPaginatorBehavior = new bc_data_table_header_paginator_behavior_1.BcDataTableHeaderPaginatorBehavior(this.bcDataTableConfig);
        this.bcDataTableFooterBehavior = new bc_data_table_footer_behavior_1.BcDataTableFooterBehavior(this.bcDataTableConfig);
        this.bcDataTableHeaderSelectionBehavior = new bc_data_table_header_selection_behavior_1.BcDataTableHeaderSelectionBehavior(this.bcDataTableConfig);
    }
    BcDataTableHeaderBehavior.prototype.setHeader = function (dataTable) {
        var headerDiv = this.setHeaderHtmlStructure();
        dataTable.parentElement.insertBefore(headerDiv, dataTable);
        return headerDiv;
    };
    BcDataTableHeaderBehavior.prototype.setHeaderSelection = function (headerDiv) {
        this.bcDataTableHeaderSelectionBehavior.init(headerDiv);
    };
    BcDataTableHeaderBehavior.prototype.setHeaderSettings = function (headerDiv) {
        if (this.bcDataTableConfig.header && this.bcDataTableConfig.header.settings) {
            this.bcDataTableHeaderSettingsBehavior.init(headerDiv);
        }
    };
    BcDataTableHeaderBehavior.prototype.setHeaderPaginator = function (headerDiv, dataTable) {
        var divHeaderPaginator = headerDiv.getElementsByClassName(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_HEADER_PAGINATOR_CLASS)[0];
        this.bcDataTableHeaderPaginatorBehavior.init(divHeaderPaginator);
        this.bcDataTableFooterBehavior.setFooter(dataTable);
    };
    BcDataTableHeaderBehavior.prototype.setHeaderHtmlStructure = function () {
        var headerDiv = this.createHeaderDiv();
        var headerDivContainer = this.createHeaderDivContainer();
        var headerSelectionDivContainer = this.createHeaderSelectionDivContainer();
        var titleDiv = this.createTitleDiv();
        var titleH4 = this.createTitleH4();
        if (this.bcDataTableConfig.header.title.icon) {
            var emElement = this.createEmElement(this.bcDataTableConfig.header.title.icon);
            titleDiv.appendChild(emElement);
        }
        titleDiv.appendChild(titleH4);
        headerDivContainer.appendChild(titleDiv);
        if (this.bcDataTableConfig.header.paginator) {
            var paginatorDiv = this.createPaginatorDiv();
            headerDivContainer.appendChild(paginatorDiv);
        }
        if (this.bcDataTableConfig.header.settings) {
            var settingsDiv = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
            settingsDiv.classList.add(bc_data_table_constants_1.BcDataTableConstansts.HEADER_SETTINGS_CLASS);
            headerDivContainer.appendChild(settingsDiv);
        }
        headerDiv.appendChild(headerDivContainer);
        headerDiv.appendChild(headerSelectionDivContainer);
        return headerDiv;
    };
    BcDataTableHeaderBehavior.prototype.createHeaderSelectionDivContainer = function () {
        var headerSelectionDiv = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        headerSelectionDiv.classList.add(bc_data_table_constants_1.BcDataTableConstansts.HEADER_SELECTION_CLASS);
        return headerSelectionDiv;
    };
    BcDataTableHeaderBehavior.prototype.createHeaderDiv = function () {
        var headerDiv = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        headerDiv.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_HEADER_CONTAINER);
        return headerDiv;
    };
    BcDataTableHeaderBehavior.prototype.createHeaderDivContainer = function () {
        var headerDivContainer = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        headerDivContainer.classList.add(bc_data_table_constants_1.BcDataTableConstansts.FLEX_CLASS, bc_data_table_constants_1.BcDataTableConstansts.JUSTIFY_CONTENT_SPACE_BETWEEN_CLASS, bc_data_table_constants_1.BcDataTableConstansts.ROW_BORDER_CLASS);
        return headerDivContainer;
    };
    BcDataTableHeaderBehavior.prototype.createTitleDiv = function () {
        var titleDiv = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        titleDiv.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_HEADER_TITLE_CLASS);
        return titleDiv;
    };
    BcDataTableHeaderBehavior.prototype.createTitleH4 = function () {
        var titleH4 = document.createElement(common_constants_1.BcCommonConstants.H4_TAG);
        titleH4.textContent = this.bcDataTableConfig.header.title.text;
        return titleH4;
    };
    BcDataTableHeaderBehavior.prototype.createPaginatorDiv = function () {
        var paginatorDiv = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        paginatorDiv.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_HEADER_PAGINATOR_CLASS);
        return paginatorDiv;
    };
    BcDataTableHeaderBehavior.prototype.createEmElement = function (icon) {
        var emElement = document.createElement(common_constants_1.BcCommonConstants.EM_TAG);
        emElement.classList.add(bc_data_table_constants_1.BcDataTableConstansts.ICON_CLASS, bc_data_table_constants_1.BcDataTableConstansts.SM_CLASS, bc_data_table_constants_1.BcDataTableConstansts.DROPDOWN_TOGGLE_CLASS);
        emElement.textContent = icon;
        return emElement;
    };
    return BcDataTableHeaderBehavior;
}());
exports.BcDataTableHeaderBehavior = BcDataTableHeaderBehavior;
